<template>
  <div>
    <el-drawer
        custom-class="buyDrawer"
        :visible.sync="dialogFormVisible"
        :direction="direction"
        :show-close="false">
      <div slot="title" class="header">
        <div class="header-l">
          <div class="header-title white">Plan upgrade</div>
          <div class="switch">
            <div class="switch-label light-color-5">Other</div>
            <el-switch v-model="showOther" @change="changeOther"></el-switch>
          </div>
        </div>
        <i class="el-icon-close" @click="closeDialog"></i>
      </div>
      <div :class="['content',{'h-100':showOther}]">
        <buyNowList ref="buyNowListRef" :showOther="showOther" @goPay="goPay"/>
      </div>
      <div v-if="!showOther" class="footer" >
        <el-button class="gradient-btn mb-5" :disabled="upgradeDisabled" @click="upgradeNow">Upgrade now!</el-button>
        <div class="footer-cancel light-color-4" @click="closeDialog">No,thanks</div>
      </div>
    </el-drawer>
    <goPay
        ref="goPayRef"
        :form1Obj="form1"
        :goodsname="goodsname"
        :discountCodeFlag="discountCodeFlag"
        pageName="shareAI"
        @openBillDetails="openBillDetails"
        @closeToBuy="closeDialog"/>

    <billingDetails
        ref="billingDetails"
        :form1Obj="form1"
    />
  </div>
</template>

<script>
import buyNowList from "@/components/buyNowList";
import goPay from "@/views/modules/phome/goPay";
import billingDetails from "@/views/modules/phome/billingDetails";
import {
  formatObj
} from "@/util/util";
import {
  mapGetters
} from 'vuex'
export default {
  name: "buyNow",
  components:{
    buyNowList,
    goPay,
    billingDetails
  },
  data() {
    return {
      dialogFormVisible:false,
      direction:'btt',
      discountCodeFlag:false,
      goodsname:'',
      form1:{
        goodsid: "",
        skuid: "",
        num: "",
        buytype: "",
        paycode: "",
        discountcode: "",
      },

    }
  },
  computed: {
    ...mapGetters({
      upgradeDisabled: 'shareAI/upgradeDisabled'
    }),
    showOther:{
      get(){
        return this.$store.state.shareAI.showOther;
      },
      set(val){
        this.$store.commit('shareAI/SET_SHOW_OTHER',val);
      }
    }
  },
  methods: {
    init(){
      this.dialogFormVisible = true;
      this.$nextTick(()=>{
        if(this.showOther){
          this.$refs['buyNowListRef'].getAllList();
        }else{
          this.$refs['buyNowListRef'].init();
        }
      })
    },
    openBillDetails(){
      this.$refs['billingDetails'].init();
    },
    changeOther(){
      this.$nextTick(()=>{
        if(this.showOther){
          this.$refs['buyNowListRef'].getAllList();
        }else{
          this.$refs['buyNowListRef'].getPartList();
        }
      })
    },
    upgradeNow(){
      let priceObj = formatObj(this.$refs['buyNowListRef']?.buyList[1]);
      let form1 = {
        buytype:'1',
        goodsid: priceObj.goodsid,
        description: priceObj.goodsname + priceObj.price + priceObj.skuname,
        discountcode:'',
        num:1,
        skuid: priceObj.id
      }
      this.goPay(formatObj(priceObj),formatObj(form1));
    },
    goPay(priceObj,form1){
      this.form1 = form1;
      this.goodsname = priceObj.goodsname;
      this.$nextTick(()=>{
        this.$refs['goPayRef'].init(priceObj);
      })
    },
    closeDialog(){
      this.dialogFormVisible = false;
      //关闭Other开关
      this.showOther = false;
      this.discountCodeFlag = false;
      this.$nextTick(()=>{
        this.$refs['buyNowListRef'].reset();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/buyNow.scss";
</style>